import { Alert, Spin, Typography } from 'antd';
import { useWindowSize } from 'hooks/useWindowSize';
import React, { useEffect, useMemo, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { isPDF } from 'utils';
import { PDFWrapper } from './style';

function PDFViewer({ file = '', widthPercent = 65 }) {
  const [numPages, setNumPages] = useState(1);
  const { width } = useWindowSize();
  const [pdfWidth, setPdfWidth] = useState(null);

  useEffect(() => {
    if (width) {
      setPdfWidth((width * widthPercent) / 100);
    }
  }, [width]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const mapPages = useMemo(() => {
    const pages = [];

    for (let i = 1; i <= numPages; i += 1) {
      pages.push(i);
    }

    return pages;
  }, [numPages]);

  return (
    <PDFWrapper>
      {isPDF(file) ? (
        <Document
          file={{
            url: file,
            httpHeaders: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }}
          loading={<Spin size="large" />}
          onLoadSuccess={onDocumentLoadSuccess}
          error={
            <Alert
              message="Произошла ошибка при загрузке pdf документа."
              type="error"
              showIcon
            />
          }
        >
          {mapPages.map((pageNum) => (
            <Page
              customTextRenderer={(v) => {
                return v.str.replace(/\s/gm, ' ');
              }}
              key={pageNum}
              className="doc"
              pageNumber={pageNum}
              width={pdfWidth}
            />
          ))}
        </Document>
      ) : (
        <Typography.Text>По этой записи нету PDF документа</Typography.Text>
      )}
    </PDFWrapper>
  );
}

export { PDFViewer };
